import { FileTreeBlock } from "@thilke/ui/blocks/file-tree-block";
import { MetricsOverviewBlock } from "@thilke/ui/blocks/metrics-overview-block";
import { RepoCardBlock } from "@thilke/ui/blocks/repo-card-block";
import {
  RollLogBlock,
  type RollLogEntry,
} from "@thilke/ui/blocks/roll-log-block";
import { ServerLogBlock } from "@thilke/ui/blocks/server-log-block";
import { StatusPageBlock } from "@thilke/ui/blocks/status-page-block";
import { WorkspaceShellBlock } from "@thilke/ui/blocks/workspace-shell";

export function WorkspaceShellBlockDemo() {
  return <WorkspaceShellBlock className="w-full max-w-4xl" />;
}

export function MetricsOverviewBlockDemo() {
  return <MetricsOverviewBlock className="w-full max-w-3xl" />;
}

export function ServerLogBlockDemo() {
  return <ServerLogBlock className="w-full max-w-2xl" />;
}

export function RepoCardBlockDemo() {
  return <RepoCardBlock className="w-full max-w-md" />;
}

export function FileTreeBlockDemo() {
  return <FileTreeBlock className="w-full max-w-md" />;
}

export function StatusPageBlockDemo() {
  return <StatusPageBlock className="w-full max-w-2xl" />;
}

const DEMO_ENTRIES: RollLogEntry[] = [
  {
    id: "roll-1",
    expression: "d20+5",
    result: 25,
    breakdown: "20 + 5",
    rolls: [20],
    speaker: "GM",
    when: Date.now() - 5_000,
    visibility: "public",
  },
  {
    id: "roll-2",
    expression: "2d6",
    result: 8,
    breakdown: "3 + 5",
    rolls: [3, 5],
    speaker: "Player",
    when: Date.now() - 30_000,
    visibility: "public",
  },
  {
    id: "roll-3",
    expression: "d20",
    result: 1,
    breakdown: "1",
    rolls: [1],
    speaker: "GM",
    when: Date.now() - 120_000,
    visibility: "public",
  },
  {
    id: "roll-4",
    expression: "3d6+2",
    result: 15,
    breakdown: "4 + 6 + 3 + 2",
    rolls: [4, 6, 3],
    speaker: "GM",
    when: Date.now() - 300_000,
    visibility: "gm-only",
  },
];

export function RollLogBlockDemo() {
  return (
    <RollLogBlock className="w-full max-w-2xl" entries={DEMO_ENTRIES} live />
  );
}
